module.exports = __webpack_public_path__ + "static/media/81eSiTPr5IL._AC_SL1500_.7c744106.jpg";